<template>
  <div style="padding:20px">Redirecting... {{ c }}</div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'SinglePart',
  async created () {
    const part = await this.getPart(this.$route.params.id)
    if (!part) {
      window.alert('part not found')
    }
    const cat = await this.getPartCategory(+part.part_category_id)
    window.location.href = `/db/${cat.root_code}/${cat.parent_code}/${cat.id}-${cat.code}?part_id=${part.id}`
  },
  methods: {
    ...mapActions('parts', ['getPart']),
    ...mapActions('partCategories', ['getPartCategory'])
  }
}
</script>
